/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
import { SheetId } from "../../commons/types/SheetId";
import { SharedLinkAccess } from "./SharedLinkAccess";
export const CreateDataClipRequest = core.serialization.object({
    name: core.serialization.string(),
    description: core.serialization.string().optional(),
    sourceSheetId: SheetId,
    collaborators: core.serialization.list(core.serialization.string()).optional(),
    sharedLinkAccess: SharedLinkAccess.optional(),
});
